import { Button, Menu, MenuItem, Popover, Position } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import React from 'react';
import { useHistory } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import { OrganisationDetailPageFragment, useDeleteOrganisationMutation } from '../../../generated/graphql';
import { showFormErrorMessage } from '../../../helpers/graphql';

type OrganisationDetailMenuProps = {
  organisation: OrganisationDetailPageFragment;
  onEdit: () => void;
};

const OrganisationDetailMenu = ({ organisation, onEdit }: OrganisationDetailMenuProps) => {
  const history = useHistory();
  const [deleteOrganisation, { loading: deleting }] = useDeleteOrganisationMutation({
    variables: {
      id: organisation.id,
    },
    onCompleted: () => {
      AppToaster.success(`${organisation.name}  wurde in den Papierkorb gelegt`);
      history.goBack();
    },
    onError: showFormErrorMessage,
  });

  return (
    <>
      <Button text="Bearbeiten" icon={IconNames.EDIT} className="ml-2" onClick={onEdit} />
      <Popover
        position={Position.BOTTOM}
        content={
          <Menu>
            <MenuItem text="In den Papierkorb" icon={IconNames.TRASH} onClick={deleteOrganisation as any} />
          </Menu>
        }
      >
        <Button icon={IconNames.MORE} className="ml-2" loading={deleting} />
      </Popover>
    </>
  );
};

export default OrganisationDetailMenu;
